export const locales = { en: 'en_GB', cs: 'cs_CZ', de: 'de_DE', pl: 'pl_PL' } as const
